import { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import StyleButton from '../../../../components/StyleButton';
import { BS_TOOLBAR_STATUS } from '../../../../comm/constant';
import LocCubicleDialog from '../LocCubicleDialog';
import useIpad from '../../../../utils/useIpad';
import { Dialog } from '../../../../components';
import rouMap from '../../../../router';
import EditFloorPlan from './EditFloorPlan';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  settingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1.142rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  divider: {
    marginTop: '1.2rem',
    width: '100%',
    height: '0.063rem',
    backgroundColor: '#d9d9d9',
  },
}));

export default function AdmissionLocationViewSetting({
  enableView,
  label,
  toolStatus,
  setToolStatus,
  showCreateCubiclePop,
  setShowCreateCubiclePop,
  cubicleList,
  setCubicleList,
  updateViewSetting,
  handleReset,
  handleUpdate,
  viewType = '',
}) {
  const classes = useStyles();
  const nextTempCubicleIdRef = useRef(-1);
  const history = useHistory();
  const [lastAddedCubicleId, setLastAddedCubicleId] = useState(null);
  const [ipadWarnPopup, setIpadWarnPopup] = useState(false);
  const isPad = useIpad();

  const handleCreateCubicle = ({ data, width, height }) => {
    const newCubicleId = nextTempCubicleIdRef.current;
    nextTempCubicleIdRef.current -= 1;

    setCubicleList((oldData) => {
      const newCubicle = {
        x: -10000,
        y: 0,
        width,
        height,
        id: newCubicleId,
        data,
      };
      setShowCreateCubiclePop(false);
      return [...oldData, newCubicle];
    });
    setLastAddedCubicleId(newCubicleId);
    setToolStatus((o) => ({
      ...o,
      type: BS_TOOLBAR_STATUS.MOVE,
    }));
  };

  const handleClearAll = () => {
    setCubicleList([]);
  };

  // 在ipad里弹出warning之后的点击事件
  const handleIpadWarning = useCallback(() => {
    history.push(rouMap.admissionRou.path);
  }, [history]);

  useEffect(() => {
    setIpadWarnPopup(isPad);
  }, [isPad]);

  return (
    <div className={classes.root}>
      <Box className={classes.settingRow}>
        <FormControlLabel
          id="ead_setting_enable_location_view_checkbox"
          control={<Checkbox />}
          label={label}
          className={classes.checkBox}
          checked={enableView}
          onChange={(event) => updateViewSetting(event.target?.checked)}
        />
        <Box display="flex" gridGap="0.857rem">
          <StyleButton onClick={handleClearAll} width="11.25rem" height="2.75rem" text="Clear All" />
          <StyleButton
            onClick={handleReset}
            width="11.25rem"
            height="2.75rem"
            text="Reset"
            type="fill"
            backgroundColor="#538fff"
          />
          <StyleButton
            onClick={() => handleUpdate(cubicleList)}
            width="11.25rem"
            height="2.75rem"
            text="Update"
            type="fill"
            backgroundColor="#28d2ab"
          />
        </Box>
      </Box>
      <div className={classes.divider} />
      <Box marginTop="1.428rem" height="calc(100% - 1.428rem)" width="100%">
        <EditFloorPlan
          tool={toolStatus}
          cubicleList={cubicleList}
          lastAddedCubicleId={lastAddedCubicleId}
          setCubicleList={setCubicleList}
          handleShowCubiclePop={() => setShowCreateCubiclePop(true)}
          handleCopyCubicle={handleCreateCubicle}
          editMode={true}
          viewType={viewType}
        />
      </Box>
      {showCreateCubiclePop && (
        <LocCubicleDialog
          showPopup={showCreateCubiclePop}
          handleClose={() => setShowCreateCubiclePop(false)}
          handleSubmit={handleCreateCubicle}
          operation="add"
          viewType={viewType}
        />
      )}
      {ipadWarnPopup && (
        <Dialog
          open={true}
          title="Reminder"
          confirm="Back"
          handleConfirm={handleIpadWarning}
          handleClose={handleIpadWarning}
        >
          Edit floor plan by iPad is not supported. Kindly edit by workstation.
        </Dialog>
      )}
    </div>
  );
}
